import axios from "axios";

const API = axios.create({

baseURL: "https://rhrmapi.up2dateinc.com/api"

});

export default API;